import vehicleSchema from "./vehicle.schema.json";
import vehicleUniqueSchema from "./vehicle_unique.schema.json";
import clientSchema from "./client.schema.json";
import contractSchema from "./contract.schema.json";

export const contractValidation = (contractData) => {
  // Vérification des champs requis
  let missingFields = [];

  // Vérification du contrat
  const contractRequiredFields = contractSchema.Root.required || [];
  if (!contractData.contract) {
    missingFields.push("Les informations du contrat sont requises");
  } else {
    contractRequiredFields.forEach((field) => {
      const value = contractData.contract[field];
      // Accepter 0 comme valeur valide pour les champs numériques
      if (value === null || value === undefined || value === "") {
        const fieldDescription =
          contractSchema.Root.properties[field]?.description || field;
        missingFields.push(`Contrat: ${fieldDescription}`);
      }
    });
  }

  // Vérification du client
  const clientRequiredFields = clientSchema.Root.required || [];
  if (!contractData.client) {
    missingFields.push("Les informations client sont requises");
  } else {
    clientRequiredFields.forEach((field) => {
      const value = contractData.client[field];
      // Accepter 0 comme valeur valide pour les champs numériques
      if (value === null || value === undefined || value === "") {
        const fieldDescription =
          clientSchema.Root.properties[field]?.description || field;
        missingFields.push(`Client: ${fieldDescription}`);
      }
    });
  }

  // Vérification des données communes du véhicule
  const vehicleRequiredFields = vehicleSchema.Root.required || [];
  if (!contractData.vehicle) {
    missingFields.push("Les informations communes du véhicule sont requises");
  } else {
    vehicleRequiredFields.forEach((field) => {
      const value = contractData.vehicle[field];
      // Accepter 0 comme valeur valide pour les champs numériques
      if (value === null || value === undefined || value === "") {
        const fieldDescription =
          vehicleSchema.Root.properties[field]?.description || field;
        missingFields.push(`Véhicule - Données communes: ${fieldDescription}`);
      }
    });
  }

  // Vérification des données spécifiques de chaque véhicule
  const vehicleUniqueFields = Object.keys(
    vehicleUniqueSchema.Root.properties || {}
  );
  if (
    !contractData.vehicleUniques ||
    !Array.isArray(contractData.vehicleUniques) ||
    contractData.vehicleUniques.length === 0
  ) {
    missingFields.push("Au moins un véhicule spécifique est requis");
  } else {
    contractData.vehicleUniques.forEach((vehicleUnique, index) => {
      if (!vehicleUnique) {
        missingFields.push(
          `Véhicule ${index + 1}: Informations spécifiques manquantes`
        );
      } else {
        vehicleUniqueFields.forEach((field) => {
          const value = vehicleUnique[field];
          // Accepter 0 comme valeur valide pour les champs numériques
          if (value === null || value === undefined || value === "") {
            const fieldDescription =
              vehicleUniqueSchema.Root.properties[field]?.description || field;
            missingFields.push(
              `Véhicule ${index + 1} - Données spécifiques: ${fieldDescription}`
            );
          }
        });
      }
    });

    return missingFields;
  }
};
